import React from 'react';
import Footer2Component from '../commons/footer2';
import Splash_Policy from '../commons/splash_policy';

import {IndexLink, Link} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

export default class ErrorPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        return (
            <div id="splash_error" className={isMobile ? "mobile-page page_other" :"page_other"}>
                <div className={"block-002"}>
                    <div className="page_wrapper">
                        <img className={"img_logo"} alt="Error 404" src="/static/img/homeimg/sad-icon_5.png"/>
                        <h1>404</h1>
                        <h3>Page not found</h3>
                        <p className="text_paragraphs">
                            The Page you are looking for doesn't exist or an other error occurred.<br/>
                            Go back, or head over the versity.co to choose a new direction.
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/error.js
 **/